import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from '../../components/LoadableLoading';

export const path = '/standards/:type';
export const service_standards_path = '/standards/service';
export const k2_design_standards_path = '/standards/k2-design-standards';
export const k2_design_standard_of_finished_objects = '/standards/k2-design-standards-of-finished-objects';
export const biot_standards_path = '/standards/biot';

const PageBIStandards: React.FC = () => {
  const BIStandards = Loadable({
    loader: () => import('./page'),
    loading: LoadableLoading,
  });

  return <BIStandards />;
};

export default PageBIStandards;
